<template>
  <div class="content">
    <h2 class="text-2xl font-bold mb-4">Credits & Attributions</h2>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Original Project</h3>
      <p>Spin the Names was originally forked from the "wheel-spinner" project created by Martin Omander. We're grateful
        for his initial work that laid the foundation for this application.</p>
      <ul class="list-disc ml-6 mt-2">
        <li>Original Repository: <a href="https://github.com/momander/wheel-spinner"
            class="text-blue-500 hover:underline" target="_blank"
            rel="noopener noreferrer">github.com/momander/wheel-spinner</a></li>
        <li>Original Creator: Martin Omander</li>
      </ul>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Technologies Used</h3>
      <p>Spin the Names is built using a variety of open-source technologies:</p>
      <ul class="list-disc ml-6 mt-2">
        <li><strong>Vue.js</strong> - The progressive JavaScript framework that powers our user interface</li>
        <li><strong>Tailwind CSS</strong> - Utility-first CSS framework for styling</li>
        <li><strong>Firebase</strong> - Backend services for authentication, database, and hosting</li>
        <li><strong>Canvas API</strong> - HTML5 technology used for wheel rendering and animations</li>
        <li><strong>Web Audio API</strong> - For sound playback capabilities</li>
        <li><strong>Vite</strong> - Frontend tooling for development and building</li>
      </ul>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Third-Party Assets</h3>
      <p>We use a variety of third-party assets to enhance the user experience:</p>
      <ul class="list-disc ml-6 mt-2">
        <li><strong>Sound Effects</strong> - Various sound effects from:</li>
        <ul class="list-disc ml-6 mt-2">
          <li><a href="https://freesound.org" class="text-blue-500 hover:underline" target="_blank"
              rel="noopener noreferrer">Freesound.org</a> (CC-licensed sounds)</li>
          <li><a href="https://soundbible.com" class="text-blue-500 hover:underline" target="_blank"
              rel="noopener noreferrer">SoundBible.com</a> (royalty-free sounds)</li>
          <li><a href="https://filmmusic.io" class="text-blue-500 hover:underline" target="_blank"
              rel="noopener noreferrer">FilmMusic.io</a> (royalty-free music)</li>
        </ul>
        <li><strong>Icons</strong> - <a href="https://fontawesome.com" class="text-blue-500 hover:underline"
            target="_blank" rel="noopener noreferrer">Font Awesome</a> for UI icons</li>
        <li><strong>Images</strong> - Various free-to-use images for wheel backgrounds and themes</li>
        <li><strong>Fonts</strong>
          <ul class="list-disc ml-6 mt-2">
            <li><a href="https://fonts.google.com" class="text-blue-500 hover:underline" target="_blank"
                rel="noopener noreferrer">Google Fonts</a> for typography</li>
            <li>Cute Dino 2 font by Khurasan Type (<a href="https://www.khurasanstudio.com"
                class="text-blue-500 hover:underline" target="_blank"
                rel="noopener noreferrer">www.khurasanstudio.com</a>) - Free for personal and commercial use</li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Contributors</h3>
      <p>Spin the Names is actively developed and maintained by an independent developer, with contributions from the
        open-source community.
        We appreciate everyone who has contributed code, reported issues, or suggested improvements to make this
        application better.</p>
    </div>

    <div class="mb-6">
      <h3 class="text-xl font-semibold mb-2">Special Thanks</h3>
      <p>We'd like to extend special thanks to:</p>
      <ul class="list-disc ml-6 mt-2">
        <li>Our users who provide valuable feedback and suggestions</li>
        <li>Educators who use the tool in their classrooms and share their experiences</li>
        <li>Open-source developers whose work makes applications like this possible</li>
      </ul>
    </div>

    <p class="mt-8 text-sm"><a href="#top" class="text-blue-500 hover:underline">Back to top</a></p>
  </div>
</template>

<script setup>
import '@components/ui/faq/faqStyles.css';
</script>
